import { render, staticRenderFns } from "./ProductPT.vue?vue&type=template&id=53fafbd6&scoped=true&"
import script from "./ProductPT.vue?vue&type=script&lang=js&"
export * from "./ProductPT.vue?vue&type=script&lang=js&"
import style0 from "./ProductPT.vue?vue&type=style&index=0&id=53fafbd6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fafbd6",
  null
  
)

export default component.exports